import { TimelineDataType } from './type';
import { Timeline } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { parseSxConfig } from '@jd/client/utils/sxParser';
import { sectionTitleMapper } from '../../../utils/mappers/sectionTitleMapper';
import { iconMapper } from '../../elements/TbIcon/mapper';

type Input = DeepNullToUndefined<Timeline>;

export const timelineMapper = (input: Input): TimelineDataType => ({
  position: input.content.position ?? 'alternate',
  items: (input.content.items ?? []).map((item) => ({
    description: item.description,
    oppositeContent: item.oppositeContent ?? undefined,
    dotColor: item.dotColor ?? 'primary',
    dotVariant: item.dotVariant ?? 'filled',
    customIcon: iconMapper(item.icon),
    id: item.id ?? undefined,
  })),
  titles: sectionTitleMapper(input.sectionTitle, input.styling?.titlesStyle),
  styling: {
    sx: parseSxConfig(input.styling?.sx),
  },
});
